// extracted by mini-css-extract-plugin
export default {"gradient-plane":"gradient-plane_gradient-plane__XYiQ7"};